import { DropDownList } from "@progress/kendo-react-dropdowns"
import { Checkbox, CheckboxChangeEvent } from "@progress/kendo-react-inputs"
import { useLocalization } from "@progress/kendo-react-intl";
import { useState } from "react";


export const FourthSequence = () => {

    const localizationService = useLocalization();

    const [checkedFourthSequence, setCheckedFourthSequence] = useState<boolean | null | undefined>(false);

    const [fourthRedValue, setFourthRedValue] = useState<any>([]);
    const [fourthGreenValue, setFourthGreenValue] = useState<any>([]);
    const [fourthBlueValue, setFourthBlueValue] = useState<any>([]);
    const [fourthBuzzerValue, setFourthBuzzerValue] = useState<any>([]);
    const [fourthVibrationValue, setFourthVibrationValue] = useState<any>([]);
    const [durationValueSelected, setDurationValueSelected] = useState<any>([]);

    var redValues:any, greenValues:any, blueValues:any, buzzzerValue:any, vibrationValue:any = [];

    redValues = greenValues = blueValues = buzzzerValue = vibrationValue = {
        "data": [
            {
                "id": 0,
                "name": 'ON'
            },
            {
                "id": 1,
                "name": 'OFF'
            },
            {
                "id": 2,
                "name": 'LF'
            },
            {
                "id": 3,
                "name": 'HF'
            }
        ]
    }

    const durationValue = {
        "data": [
            {
                "id": 0,
                "name": '1s'
            },
            {
                "id": 1,
                "name": '0'
            },
            {
                "id": 2,
                "name": '500ms'
            },
            {
                "id": 3,
                "name": '2s'
            }
        ]
    }

    const handleFourthSequence = (event: CheckboxChangeEvent) => {
        setCheckedFourthSequence(event.value);
    };

    const onFourthRedValueChange = (event: any) => {
        setFourthRedValue(event.value)
    }

    const onFourthGreenValueChange = (event: any) => {
        setFourthGreenValue(event.value)
    }

    const onFourthBlueValueChange = (event: any) => {
        setFourthBlueValue(event.value)
    }

    const onFourthBuzzerValueChange = (event: any) => {
        setFourthBuzzerValue(event.value)
    }

    const onFourthVibrationValueChange = (event: any) => {
        setFourthVibrationValue(event.value)
    }

    const onFourthDurationValueChange = (event: any) => {
        setDurationValueSelected(event.value)
    }
    
    return (

        <div style={{ display: 'inline-flex', width: '100%' }}>

            <div style={{ color: '#1A8995', textAlign: 'left', margin: '25px 0px 0px 0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_enabled', 'NOT_FOUND')}</div>
            <Checkbox
                //label={localizationService.toLanguageString('configuration.rules.subscription_backchannel_enabled', 'NOT_FOUND')}
                checked={checkedFourthSequence}
                style={{ marginTop: '30px', marginRight: '20px', marginLeft: '10px' }}
                onChange={handleFourthSequence}
            />

            <div style={{ display: 'inline', marginRight: '10px', marginLeft: '10px', width: '105px' }}>
                <div style={{ textAlign: 'left', color: 'red' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_red', 'NOT_FOUND')}</div>
                <DropDownList
                    data={redValues.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onFourthRedValueChange}
                />
            </div>
            <div style={{ display: 'inline', marginRight: '10px', width: '105px' }}>
                <div style={{ textAlign: 'left', color: 'green' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_green', 'NOT_FOUND')}</div>
                <DropDownList
                    data={redValues.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onFourthGreenValueChange}
                />
            </div>
            <div style={{ display: 'inline', marginRight: '10px', width: '105px' }}>
                <div style={{ textAlign: 'left', color: 'blue' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_blue', 'NOT_FOUND')}</div>
                <DropDownList
                    data={redValues.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onFourthBlueValueChange}
                />
            </div>
            <div style={{ display: 'inline', marginRight: '10px', width: '105px' }}>
                <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_buzzer', 'NOT_FOUND')}</div>
                <DropDownList
                    data={redValues.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onFourthBuzzerValueChange}
                />
            </div>
            <div style={{ display: 'inline', marginRight: '10px', width: '105px' }}>
                <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_vibration', 'NOT_FOUND')}</div>
                <DropDownList
                    data={redValues.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onFourthVibrationValueChange}
                />
            </div>
            <div style={{ display: 'inline', marginRight: '10px', width: '120px' }}>
                <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_duration', 'NOT_FOUND')}</div>
                <DropDownList
                    data={durationValue.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onFourthDurationValueChange}
                />
            </div>

        </div>
    )
}